import { useHasScope as hasScope } from "../../../../config/globalConfig";
import React, { useEffect, useState, useRef, useReducer  } from 'react';
import { 
  Dialog, DialogTitle, DialogContent, 
  DialogActions,Button,ButtonProps , TextField,Tooltip,
  Grid,  Box, Paper,IconButton
} from '@mui/material';
import { Formik, Field} from 'formik';
import { VehicleCommandActions,CommandRequest,VehicleStatusRequest, useCustomTranslation, vehicleCommandRepoUtil } from "../../service/vehicle.command.actions";
import * as Icons from '@mui/icons-material';
import Alert from '@mui/material/Alert';
import "./Vehicle.css";


import Backdrop from '@mui/material/Backdrop';
import CircularProgress from '@mui/material/CircularProgress';
import { useTheme } from '@mui/material/styles';

// Funzione per forzare il re-render
function useForceUpdate() {
  const [, dispatch] = useReducer(x => x + 1, 0);
  return dispatch;
}

// ==============  aggacio da esterno =================
interface CviFormDialogProps {
  t: any; 
  vehicleCommandActions: VehicleCommandActions; 
  paramValues: VehicleStatusRequest;
  initialSetting?: any;
  open: boolean;
  onClose: () => void;
  onSubmit: (values: any) => void;
}

const CviFormDialogWrapper = (props:any) => {
  const t = useCustomTranslation();
  const vehicleCommandActions = new VehicleCommandActions();
  return <CviFormDialog t={t} vehicleCommandActions={vehicleCommandActions} {...props} />;
};
export const vehicleStub=vehicleCommandRepoUtil;
export default CviFormDialogWrapper;


//============ gestione buttoni - comandi ==================== 

interface CustomButtonProps extends ButtonProps {
  icon?: React.ReactNode;
  text: string;
  onClick?: (event: React.MouseEvent<HTMLButtonElement>, params?: any) => void;
  params?: any; // Parametri opzionali da passare all'evento onClick
}

const CustomButton: React.FC<CustomButtonProps> = ({ icon, text, onClick, params, ...buttonProps }) => {
  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    if (onClick) {
      params.text=text;
      onClick(event, params); // Chiamata dell'evento onClick con i parametri aggiuntivi
    }
  };
  let inibition:any = true;
  try {
	if ("RELOAD" === params.ev) {
		inibition=false;
	} else if(params?.inibition){
		inibition = !(params.inibition);
    }
  } catch (error) {
      console.log("p.n non riesco a fare il confronto....", error);
  }
    let enable:any = true;
  if(params?.data?.commandDisabled.includes(params.ev)){
    enable=false;
  }
  return (
    <Button
      variant="contained"
      startIcon={icon}
      fullWidth={true}
      disabled={inibition}
      sx={{ margin: '5px 0', justifyContent: 'flex-start', whiteSpace: 'nowrap' }}
	  onClick={!inibition ? handleClick : undefined}
      {...buttonProps}
    >
      {text}
    </Button>
  );
};


//======================= gestione rotelina =========================

const LoadingBackdrop: React.FC<{ loading: boolean }> = ({ loading }) => {
  const theme = useTheme();
  return (
    <Backdrop sx={{ color: '#ffffff', zIndex: theme.zIndex.drawer + 1 }} open={loading} >
      <Box sx={{ display: 'grid', placeItems: 'center',  alignContent: 'center'}}>
        <CircularProgress size={94} sx={{ color: '#FFFFFF', opacity: '80%' }} />
      </Box>
    </Backdrop>
  );
};



//======================  gestione maschera ======================

const CviFormDialog: React.FC<CviFormDialogProps> = ({
  t,
  vehicleCommandActions,
  paramValues,
  initialSetting,
  open,
  onClose,
  onSubmit,
}) => {
  const [data, setData] = useState<any>(null);
  const [loading, setLoading] = useState<boolean>(true);
  const [message, setMessage] = useState<{ text: string, level: 'error' | 'info' | 'warning' | 'success' } | null>(null);
  const [messageClean, setMessageClean] = useState<boolean>(true);
  const validationSchema = vehicleCommandActions.generateVehicleStatusDataSchema(); 

  const paramValuesDizObject = Object.fromEntries(
    Object.entries(paramValues).map(([key, value]) => [key, `<span class='spanTextColor'>${value}</span>`])
  );
  const title = t("title.win",paramValuesDizObject);
  const [refreshKey, setRefreshKey] = useState<number>(0); // Aggiungi un refresh key

  
  const mapCommandToCode = (ev: string): number => {
    switch (ev) {
      case "ENGINELOCK":
        return 1;
      case "ENGINEUNLOCK":
        return 2;
      case "DOORSLOCK":
        return 3;
      case "DOORSUNLOCK":
        return 4;
      case "REQUESTPOSITION":
        return 1000;
      case "REQUESTSTATUS":
        return 2000;
      case "RESETBOARD":
        return 3000;
      default:
        return -1;
    }
  };
  
  
  
  const handleCustomAction = async (event: React.MouseEvent<HTMLButtonElement>, params: any) => {
    setLoading(true);
    if ("RELOAD" === params.ev) {
      setRefreshKey((prevKey) => prevKey + 1); // Ricarica il dialog
      return;
    }
    const commandCode = mapCommandToCode(params.ev);
    if (commandCode === -1) {
      alert('Comando non implementato...');
      setRefreshKey((prevKey) => prevKey + 1); // Ricarica il dialog
      return;
    }
    const req: any = {
      vehicleId: {
        vin: params?.data?.data.vin,
      },
      cmdId: commandCode,
    } as CommandRequest;

    try {
      let cnf = await askConfirmation(params?.text);
      if (cnf) {
        console.log('CviFormDialog:handleCustomAction:askConfirmation:Confirmed!');
        let resp: any | null = null;
        let respService: string | null = null;
        if (commandCode === 1000) {
          delete req.cmdId;
          respService = 'vehicleLocation';
          resp = await vehicleCommandActions.vehicleLocation(req); // Aspetta la risposta
        } else if (commandCode === 2000) {
          delete req.cmdId;
          respService = 'vehicleBoxStatus';
          resp = await vehicleCommandActions.vehicleBoxStatus(req); // Aspetta la risposta
        } else if (commandCode === 3000) {
          delete req.cmdId;
          respService = 'vehicleResetBoxStatus';
          resp = await vehicleCommandActions.vehicleResetBoxStatus(req); // Aspetta la risposta
        } else {
          respService = 'vehicleCommand';
          resp = await vehicleCommandActions.vehicleCommand(req); // Aspetta la risposta
        }
        onMessage(respService, resp, req);
        setMessageClean(false);
        // Aggiorna solo dopo che la chiamata è stata completata
        setRefreshKey((prevKey) => prevKey + 1);
      } else {
        console.log('CviFormDialog:handleCustomAction:askConfirmation:Cancelled!');
      }
    } catch (error) {
      console.error('CviFormDialog:handleCustomAction:Errore durante l\'esecuzione del comando:', error);
    } finally{
      setLoading(false);
    }

  };

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true); // Inizia a caricare
      try {
        //console.log('This is a function inside CviFormDialog:req:' + JSON.stringify(paramValues));
        const response = await vehicleCommandActions.vehicleStatus(paramValues);
        setData(response);
        setLoading(false);
        onMessage('vehicleStatus', response, paramValues);
      } catch (error) {
        onMessage('vehicleStatus', error, paramValues);
        setLoading(false);
      } finally {
        setLoading(false); // Finisci di caricare
      }
    };

    if (open) {
      fetchData();
    }
  }, [open, refreshKey]); // Aggiungi refreshKey alla dipendenza


  
  
  const MESSAGE_CODE = new Map<string, string>([
    ['OK', '200'],
    ['COMMAND_NOT_EXECUTED', '201'],
    ['INVALID_TIMEOUT', '203'],
    ['INVALID_CALLBACK_URL', '204'],
    ['VEHICLE_NOT_FOUND', '202'],
    ['VEHICLE_BUSY', '205'],
    ['NOT_CONFIGURED', '207'],
    ['TIMEOUT_EXPIRED', '206'],
    ['TRANSMISSION_FAILED', '198'],
    ['SYS_ERROR', '199'],
    ['SYS_ERROR_COMUNICATION', '500'],
    ['NOT_FOUND', '404'],
  ]);

  function getNameByCode(code: string): string {
    let result = 'ND';
    MESSAGE_CODE.forEach((value, key) => {
      if (value === code) result = key;
    });
    return result;
  }
  const onMessage = (service:string, resp: any, req: any) => {
    let keyMsg = getNameByCode(resp?.statusCode);
    let keyMsgTxt = t('MSG_'+keyMsg);//+' [service:'+service+' code:'+resp?.statusCode+']';
    if('vehicleStatus'===service){
      if(messageClean===false && ('OK' === keyMsg)){
        setMessageClean(true);
        return;
      }
    }
    //'error' | 'info' | 'warning' | 'success' 
    if('OK' === keyMsg){
      setMessage({ text: keyMsgTxt, level: 'success' });
    } else if(['SYS_ERROR','SYS_ERROR_COMUNICATION','NOT_FOUND'].includes(keyMsg)){
      setMessage({ text: keyMsgTxt, level: 'error' });
    } else {
      setMessage({ text: keyMsgTxt, level: 'warning' });
    }
  }
  

  
    
    interface EnhancedFieldProps {
      path: string;
      keyName: string; // Evita conflitti con la parola chiave "key"
      value: string | null;
      timestamp: string | null;
    }

    const EnhancedField: React.FC<EnhancedFieldProps> = ({ path, keyName, value, timestamp }) => {
      
      const valueRefered = useRef<string>(value || "N/A");
      const coordinateRefered = useRef<string>(value || "0.0,0.0");
      const forceUpdate = useForceUpdate();
 
      
      const renderLabel = () => {
        let disabled:any = false;
        if (keyName === 'location') {
          if (!valueRefered || valueRefered.current === 'N/A') {
            // Caso 1: N/A
            return `${keyName} (${timestamp || 'N/A'})`;
          }

          if (valueRefered.current && valueRefered.current.startsWith('N/A ')) {
            // Caso 2: Coordinate in formato "N/A lat, lng"
            coordinateRefered.current=valueRefered.current.replace('N/A ', '');
            const [lat, lng] = coordinateRefered.current.split(',').map((v) => v.trim());
            const cachedKey = `${lat}_${lng}`; // Chiave per il localStorage
            const cachedAddress = sessionStorage.getItem(cachedKey);
            return (
              <>
                <Tooltip title="Trova indirizzo">
                  <IconButton 

                    onClick={
                       async () => {
                          if (cachedAddress) {
                              valueRefered.current = cachedAddress;
                          } else {
                              valueRefered.current = await vehicleCommandActions.fetchAddressSync(lat, lng, t);
                          }
                          if (!cachedAddress) {
                              sessionStorage.setItem(cachedKey, valueRefered.current);
                          }
                          
                          forceUpdate();
                      }}
 
                    style={{ marginTop: '-8px'}} >
                    <Icons.Place />
                  </IconButton>
                </Tooltip>
                {`${t(keyName)}`}
              </>
            );
          }

          // Caso 3: Indirizzo completo
          return (
            <>
              <Tooltip title="Apri su Google Maps">
                <IconButton
                  href={`https://www.google.com/maps?q=${coordinateRefered.current}`}
                  target="_blank"
                  style={{ marginTop: '-8px' }}
                >
                  <Icons.Map />
                </IconButton>
              </Tooltip>
              {`${t(keyName)}`}
            </>
          );
        }

        // Caso predefinito (non location)
        return `${t(keyName)}`;
      };

      return (
        <>
          <TextField
            name={`${path}.${keyName}.value`}
            id={`${path}.${keyName}.value`}
            label={renderLabel()}
            value={valueRefered.current}
            helperText={timestamp}
            variant="standard"
            fullWidth
            multiline={keyName === 'location'}
            maxRows={4}
            />
        </>
      );
    };

    
    
    

    // Esempio di utilizzo in renderSection
    const renderSection = (
      title: string,
      fields: Record<string, { type: string | null; value: string | null; timestamp: string | null } | null>,
      path: string
    ) => (
      <Grid item xs={12} key={title}>
        <Paper elevation={3} style={{ padding: '16px' }}>
          <Grid container spacing={2}>
            {Object.entries(fields).map(([key, field]) => {
              if (!field) {
                console.log(`CviFormDialog:renderSection: Key: ${key} has a null value`);
                return null;
              }
              return (
                <Grid item xs={12} sm={6} key={key}>
                  <EnhancedField 
                      path={path} 
                      keyName={key} 
                      value={field.value} 
                      timestamp={field.timestamp} 
                    />
                </Grid>
              );
            })}
          </Grid>
        </Paper>
      </Grid>
    );
  

  const readonly=(data?.statusCode !== '200')?true:false;
  
  
  
  
  
  
  
  //==================CONFIRMATION_DIALOG==================
  const [openConfirm, setOpenConfirm] = useState(false);
  const [resolvePromise, setResolvePromise] = useState<(value: boolean) => void>();
  const [openConfirmParams, setOpenConfirmParams] = useState<string | null>(null);
  
  // Funzione per chiedere conferma, restituisce una Promise
  const askConfirmation = (text:string): Promise<boolean> => {
    setOpenConfirm(true);setOpenConfirmParams(text);
    return new Promise((resolve) => {
      setResolvePromise(() => resolve);
    });
  };

  // Funzioni per confermare o annullare
  const handleConfirm = () => {
    setOpenConfirm(false);
    if (resolvePromise) resolvePromise(true);
  };

  const handleCancel = () => {
    setOpenConfirm(false);
    if (resolvePromise) resolvePromise(false);
  };
  interface ConfirmationDialogProps {
    title?: string;
    message?: string;
  }

  const ConfirmationDialog: React.FC<ConfirmationDialogProps> = ({
    title = "Confirm Action",
    message = "Are you sure you want to proceed?"
  }) => {
    return (
      <Dialog
         id="confirmation-dialog"
         open={openConfirm} 
         disableEscapeKeyDown
         container={document.getElementById('confirmation-dialog')} // Usa un container separato
         onClose={(_, reason) => {
             if (reason === 'backdropClick' || reason === 'escapeKeyDown') {
               // Ignora il clic sul backdrop o il tasto ESC
               return;
             }
         }}
         aria-labelledby="form-dialog-title">
        <DialogTitle>{t("DIA_CONFIRM_TITLE")}</DialogTitle>
        <DialogContent>
          <p>{t("DIA_CONFIRM_MSG", { param: openConfirmParams })}</p>
        </DialogContent>
        <DialogActions sx={{ display: 'flex', justifyContent: 'flex-end' }}>
          <Button
            variant="contained"
            sx={{
              margin: '5px 0',
              whiteSpace: 'nowrap',
              maxWidth: 'auto', // Assicura che il bottone non occupi tutta la larghezza
            }}
            onClick={handleConfirm}>
            {t("DIA_CONFIRM_OK")}
          </Button>
          <Button
            variant="contained"
            sx={{
              margin: '5px 0',
              whiteSpace: 'nowrap',
              maxWidth: 'auto', // Assicura che il bottone non occupi tutta la larghezza
            }}
            onClick={handleCancel}>
            {t("DIA_CONFIRM_CANCEL")}
          </Button>
        </DialogActions>

      </Dialog>
    );
  };
  
  

  const inhibitionCommand: Record<string, boolean> = {
    "RESETBOARD": hasScope("SCOPE_VEHICLE_SEND_COMMAND_RESETBOARD"),
    "REQUESTSTATUS": hasScope("SCOPE_VEHICLE_SEND_COMMAND_REQUESTSTATUS"),
    "REQUESTPOSITION": hasScope("SCOPE_VEHICLE_SEND_COMMAND_REQUESTPOSITION"),
    "DOORSUNLOCK": hasScope("SCOPE_VEHICLE_SEND_COMMAND_DOORSUNLOCK"),
    "DOORSLOCK": hasScope("SCOPE_VEHICLE_SEND_COMMAND_DOORSLOCK"),
    "ENGINEUNLOCK": hasScope("SCOPE_VEHICLE_SEND_COMMAND_ENGINEUNLOCK"),
    "ENGINELOCK": hasScope("SCOPE_VEHICLE_SEND_COMMAND_ENGINELOCK")
  } 

  
  
  
  
  
  return (
    <Dialog
      open={open}
      aria-labelledby="form-dialog-title"
      onClose={(_, reason) => {
        if (reason !== 'backdropClick') {
          onClose();
        }
      }}
      fullWidth
      maxWidth="lg">


        
      <DialogTitle id="form-dialog-title" dangerouslySetInnerHTML={{ __html: title }} />
      <DialogContent>
        {/*loading && <p>{t("title.loading")}</p>*/}
        {/*error && <p>{t("title.loading.error",error.message)}</p>*/}
        
        {data && data.data && (
          <Formik
            initialValues={data}
            validationSchema={validationSchema}
            validateOnChange={false}
            validateOnBlur={false}
            onSubmit={onSubmit}
          >

          
                 <Grid container spacing={3}>
                    {/* Prima colonna - dati */}
                    <Grid item xs={4} sm={9}>
                      <Grid container spacing={3}>
                        {/*renderSection('Location Data', data.data.locationData, 'locationData')*/}
                        {renderSection('Status Data', data.data.statusData, 'statusData')}
                        {/*renderSection('Statistics', data.data.statsData, 'statsData')*/}
                      </Grid>
                    </Grid>
					

					if(hasScope("SCOPE_VEHICLE_SEND_COMMAND_USER")){
						data.commandDisabled=['RESETBOARD']
					}


                    {/* Seconda colonna - pulsanti */}
                    <Grid item xs={1} sm={3}>
                      <Grid container spacing={2} direction="column" sx={{ marginTop: 0 }}>
                        <CustomButton
                          icon={<Icons.LockOpen />}
                          text={t("bltUnlockDoors")}
                          onClick={!readonly ? handleCustomAction : undefined}
                          params={{ ev: 'DOORSUNLOCK', data, inibition: inhibitionCommand['DOORSUNLOCK'] }}
                          style={{
                            opacity: readonly ? 0.5 : 1,
                            pointerEvents: readonly ? 'none' : 'auto', // Rimuove completamente il click
                            cursor: readonly ? 'not-allowed' : 'pointer',
                          }}
                        />
                        <CustomButton
                          icon={<Icons.Lock />}
                          text={t("bltLockDoors")}
                          onClick={!readonly ? handleCustomAction : undefined}
                          params={{ ev: 'DOORSLOCK', data,  inibition: inhibitionCommand['DOORSLOCK'] }}
                          style={{
                            opacity: readonly ? 0.5 : 1,
                            pointerEvents: readonly ? 'none' : 'auto', // Rimuove completamente il click
                            cursor: readonly ? 'not-allowed' : 'pointer',
                          }}
                        />
                        <CustomButton
                          icon={<Icons.RadioButtonUnchecked />}
                          text={t("bltUnlockEngine")}
                          onClick={!readonly ? handleCustomAction : undefined}
                          params={{ ev: 'ENGINEUNLOCK', data,  inibition: inhibitionCommand['ENGINEUNLOCK'] }}
                          style={{
                            opacity: readonly ? 0.5 : 1,
                            pointerEvents: readonly ? 'none' : 'auto', // Rimuove completamente il click
                            cursor: readonly ? 'not-allowed' : 'pointer',
                          }}
                        />
                        <CustomButton
                          icon={<Icons.RadioButtonChecked />}
                          text={t("bltLockEngine")}
                          onClick={!readonly ? handleCustomAction : undefined}
                          params={{ ev: 'ENGINELOCK', data,  inibition: inhibitionCommand['ENGINELOCK'] }}
                          style={{
                            opacity: readonly ? 0.5 : 1,
                            pointerEvents: readonly ? 'none' : 'auto', // Rimuove completamente il click
                            cursor: readonly ? 'not-allowed' : 'pointer',
                          }}
                        />
                        <CustomButton
                          icon={<Icons.Radar />}
                          text={t("bltRequestPosition")}
                          onClick={!readonly ? handleCustomAction : undefined}
                          params={{ ev: 'REQUESTPOSITION', data,  inibition: inhibitionCommand['REQUESTPOSITION'] }}
                          style={{
                            opacity: readonly ? 0.5 : 1,
                            pointerEvents: readonly ? 'none' : 'auto', // Rimuove completamente il click
                            cursor: readonly ? 'not-allowed' : 'pointer',
                          }}
                        />
                        <CustomButton
                          icon={<Icons.BluetoothConnected />}
                          text={t("bltRequestStatus")}
                          onClick={!readonly ? handleCustomAction : undefined}
                          params={{ ev: 'REQUESTSTATUS', data,  inibition: inhibitionCommand['REQUESTSTATUS'] }}
                          style={{
                            opacity: readonly ? 0.5 : 1,
                            pointerEvents: readonly ? 'none' : 'auto', // Rimuove completamente il click
                            cursor: readonly ? 'not-allowed' : 'pointer',
                          }}
                        />
                        <CustomButton
                          icon={<Icons.RestartAlt />}
                          text={t("bltResetBoard")}
                          onClick={!readonly ? handleCustomAction : undefined}
                          params={{ ev: 'RESETBOARD', data, inibition: inhibitionCommand['RESETBOARD']  }}
                          style={{
                            opacity: readonly ? 0.5 : 1,
                            pointerEvents: readonly ? 'none' : 'auto', // Rimuove completamente il click
                            cursor: readonly ? 'not-allowed' : 'pointer',
                          }}
                        />
                      </Grid>
                    </Grid>
                  </Grid>

           </Formik>
        )}
      </DialogContent>
      
      
      
      <DialogActions >
        <Grid container spacing={2} alignItems="center">
          {/* Colonna 1: Messaggio */}
          <Grid item xs={12} sm={6}  style={{ display: "flex", alignItems: "center" }}>
            {message && (
              <Alert
                variant="outlined"
                severity={message.level} // Cambia in "info", "warning", o "success" se necessario
                style={{border: "0px",flexGrow: 1}}
              >
                {message.text}
              </Alert>
            )}
          </Grid>

          {/* Colonna 2: Pulsanti */}
          <Grid item xs={12} sm={6} style={{display: "flex",justifyContent: "flex-end",flexWrap: "nowrap"}}
          >
            {data && (
              <CustomButton
                icon={<Icons.Refresh />}
                text={t("bltRefresh")}
                onClick={handleCustomAction}
                fullWidth={false}
                params={{ ev: "RELOAD", data }}
              />
            )}
            <Button
              variant="contained"
              sx={{
                margin: '5px 5px',
                whiteSpace: 'nowrap',
                maxWidth: 'auto',
              }}
              onClick={onClose} >
              {t("bltClose")}</Button>
          </Grid>
        </Grid>
      </DialogActions>



      <ConfirmationDialog />

      <LoadingBackdrop loading={loading} />
      
    </Dialog>


        );

      
};


